module.exports = __webpack_public_path__ + "static/media/letter_s.63e3ca11.svg";